import { BaseResponse } from '~/types/http';

export default class SWRError extends Error {
  constructor(message: string, status: number, params: any, response?: BaseResponse<any>) {
    super(message);
    this.status = status;
    this.name = 'SWRError';
    this.params = params;
    this.response = response;
  }

  public status: number;

  public params: any;

  public response?: BaseResponse<any>;
}
